

import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Container, Paper, Typography, Grid, Card, CardContent,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, IconButton, Chip, Dialog, DialogTitle, DialogContent,
  DialogActions, TextField, FormControl, InputLabel, Select,
  MenuItem, FormGroup, FormControlLabel, Checkbox, Alert,
  CircularProgress, Tabs, Tab, FormLabel, RadioGroup, Radio,
  DialogContentText, Divider, InputAdornment, Tooltip, ToggleButtonGroup,ListItemText,
  ToggleButton, CardActions
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  LocalOffer as OfferIcon,
  TrendingUp as TrendingUpIcon,
  People as PeopleIcon,
  ShoppingCart as ShoppingCartIcon,
  Search as SearchIcon,
  GridView as GridViewIcon,
  ViewList as ViewListIcon
} from '@mui/icons-material';
import CustomDialog from '../../CustomDialog';
import axios from 'axios';
import ReferralConfigTab from "./ReferralConfigTab";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const promotionlistapi = process.env.REACT_APP_PROMOTION_LIST_API;
const promotionanalyticsapi = process.env.REACT_APP_PROMOTION_ANALYTICS_API;
const createpromotionsapi = process.env.REACT_APP_CREATE_PROMOTION_API;
const baseDiagnosticApi=process.env.REACT_APP_BASE_DIAGNOSTIC_TESTS;
const offersapi=process.env.REACT_APP_APPLY_PROMOTION_API

const PromotionDashboard = () => {
  const [tabValue, setTabValue] = useState(0);
  const [promotions, setPromotions] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [viewMode, setViewMode] = useState('cards');
  const [searchQuery, setSearchQuery] = useState('');
  
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [diagnosticCategories, setDiagnosticCategories] = useState([]);
  const [diagnosticTests, setDiagnosticTests] = useState([]);
  const [catLoading, setCatLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [promoMsg, setPromoMsg] = useState("")
  const [promotype, setPromotype] = useState("")
  const [communities, setCommunities] = useState([]);
  const [formData, setFormData] = useState({
    promo_code: '',
    title: '',
    description: '',
    status: 'active',
    usage_limit: '',
    usage_per_user: '',
    min_order_value: '',
    discount_amount: '',
    discount_perc: '',
    max_discount: '',
    start_date: new Date().toISOString().slice(0, 16),
    end_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16),
    service_types_supported: [],
    diagnostic_category: [],
    applicable_tests: [],
    community:""
  });
const [offers, setOffers] = useState([]);
const [offerDialogOpen, setOfferDialogOpen] = useState(false);
const [editingOffer, setEditingOffer] = useState(null);

const [offerForm, setOfferForm] = useState({
  type: "offer",
  active: true,
  priority: 0,

  tag: "",
  headline: "",
  sub: "",
  body: "",

  visual: "💊",

  bigNumber: "",
  bigLabel: "",

  pills: [],

  accentColor: "#80ED99",
  glowColor: "rgba(128,237,153,0.35)",

  backgroundImage: "/med_icon5.png",

  whatsappNumber: "",
  phoneNumber: "",

  buttonLabel: "WhatsApp Order →",
  secondaryButtonLabel: "Call Now",
  community:""
});
  const [discountType, setDiscountType] = useState('flat');

  const SERVICE_TYPES = [
    { value: 'medicine', label: 'Medicine' },
    { value: 'diagnostic', label: 'Diagnostic' },
    { value: 'nursingAndPhysio', label: 'Nursing and Physio' },
    { value: 'all', label: 'All Services' },
  ];

  useEffect(() => {
    fetchPromotions();
    fetchAnalytics();
    fetchOffers();
  }, []);
 const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success",
    });
const API_URL = process.env.REACT_APP_API

useEffect(() => {
    fetchCommunities()
   },[])
  const fetchCommunities = async () => {
  
      try {
  
        const response = await axios.get(
          `${API_URL}/community/config`
        );
  
        setCommunities(
          response.data.communities || []
        );
  
      } catch (error) {
  
        console.error(
          "Error fetching communities:",
          error
        );
  
        showSnackbar(
          "Failed to load communities",
          "error"
        );
  
      } 
    };

 
const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };


  const fetchPromotions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${promotionlistapi}`);
      setPromotions(response.data.promotions || []);
      setError('');
    } catch (err) {
      setError('Failed to fetch promotions');
    } finally {
      setLoading(false);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const response = await axios.get(`${promotionanalyticsapi}`);
      if (response.data.success) {
        setAnalytics(response.data.analytics);
      }
    } catch (err) {
      console.error('Failed to fetch analytics:', err);
      const response = await axios.get(`${promotionlistapi}`);
      const promos = response.data.promotions || [];
      const active = promos.filter(p => p.status === 'active').length;
      setAnalytics({
        total_promotions: promos.length,
        active_promotions: active,
        inactive_promotions: promos.length - active,
        total_usage_limit: promos.reduce((sum, p) => sum + (p.usage_limit || 0), 0)
      });
    }
  };
  const handleSaveOffer = async () => {
  try {

    if (editingOffer) {
      await axios.put(
        `${offersapi}/daily-offer/${editingOffer.id}`,
        offerForm
      );
    } else {
      await axios.post(
        `${offersapi}/daily-offer`,
        offerForm
      );
    }

    setOfferDialogOpen(false);
    setEditingOffer(null);

    fetchOffers();

    setSuccess("Offer saved successfully");

  } catch (err) {
    setError("Failed to save offer");
  }
};
const handleDeleteOffer = async (id) => {
  try {

    await axios.delete(
      `${offersapi}/daily-offer/${id}`
    );

    fetchOffers();

    setSuccess("Offer deleted successfully");

  } catch (err) {
    setError("Failed to delete offer");
  }
};
   useEffect(() => {
      const fetchCategories = async () => {
        setCatLoading(true);
        try {
          const res = await axios.get(`${baseDiagnosticApi}/diagnostic-categories`);
              const updatedCategories = [
        ...res.data.categories
      ];
       setDiagnosticCategories(updatedCategories);
        } catch {
          setError("Failed to load categories.");
        } finally {
          setCatLoading(false);
        }
      };
      fetchCategories();
    }, []);

  const fetchDiagnosticTests = async (categories) => {
  try {
    let allTests = [];

    for (const category of categories) {
      const params = new URLSearchParams({
        page: 1,
        limit: 1000,
        category
      });

      const response = await axios.get(
        `${baseDiagnosticApi}/diagnostic-tests?${params}`
      );

      allTests.push(...(response.data.tests || []));
    }

    // remove duplicates
    const uniqueTests = Array.from(
      new Map(allTests.map(test => [test.id, test])).values()
    );

    setDiagnosticTests(uniqueTests);

  } catch (err) {
    console.error("Failed to fetch tests");
  }

};
  const resetForm = () => {
    setFormData({
      promo_code: '',
      title: '',
      description: '',
      status: 'active',
      usage_limit: '',
      usage_per_user: '',
      min_order_value: '',
      discount_amount: '',
      discount_perc: '',
      max_discount: '',
      start_date: new Date().toISOString().slice(0, 16),
      end_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16),
      service_types_supported: [],
      diagnostic_category: [],
      applicable_tests: [],
      community:""
    });
    setDiscountType('flat');
  };
  const fetchOffers = async () => {
  try {
    const response = await axios.get(
      `${offersapi}/daily-offer`
    );

    if (response.data.success) {
      setOffers(response.data.data || []);
    }
  } catch (err) {
    console.error(err);
  }
};

  const handleCreateOpen = () => {
    resetForm();
    setCreateDialogOpen(true);
  };

  const handleEditOpen = (promo) => {
    setSelectedPromo(promo);
    const isFlat = promo.discount_amount > 0;
    setDiscountType(
      promo.fixed_price > 0
        ? "fixed_price"
        : promo.discount_amount > 0
          ? "flat"
          : "percentage"
    );
    
    setFormData({
      promo_code: promo.promo_code,
      title: promo.title,
      description: promo.description || '',
      status: promo.status,
      usage_limit: promo.usage_limit,
      usage_per_user: promo.usage_per_user,
      min_order_value: promo.min_order_value,
      discount_amount: promo.discount_amount || '', 
      discount_perc: promo.discount_perc || '',
      fixed_price:promo.fixed_price || 0,
      max_discount: promo.max_discount || '',
      start_date: formatDateTimeLocal(promo.start_date),
      end_date: formatDateTimeLocal(promo.end_date),
      community:promo.community,
      service_types_supported: promo.service_types_supported || [],
      diagnostic_category:  Array.isArray(promo.diagnostic_category)
  ? promo.diagnostic_category
  : promo.diagnostic_category
    ? [promo.diagnostic_category]
    : [],
      applicable_tests: promo.applicable_tests || [], // ADD THIS
      
    });
    if (promo.diagnostic_category.length > 0) {
    fetchDiagnosticTests(promo.diagnostic_category);
  }

    setEditDialogOpen(true);
  };
  const handleDeleteOpen = (promo) => {
    setSelectedPromo(promo);
    setDeleteDialogOpen(true);
  };

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    console.log(name)
    console.log(value)
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }, []);
  const handleServiceTypeChange = useCallback((e) => {
    const { value, checked } = e.target;
  
    setFormData((prev) => {
      let updated = [...prev.service_types_supported];
  
      if (value === "all") {
        // All selected → select both
        updated = checked ? ["medicine", "diagnostic","nursingAndPhysio"] : [];
      } else {
        if (checked) {
          updated.push(value);
        } else {
          updated = updated.filter((v) => v !== value);
        }
      }
  
      return {
        ...prev,
        service_types_supported: Array.from(new Set(updated)),
      };
    });
  }, []);
  
  const handleDiscountTypeChange = useCallback((e) => {
    const type = e.target.value;
    setDiscountType(type);
    if (type === 'flat') {
      setFormData(prev => ({ ...prev, discount_perc: 0, max_discount: 0 }));
    } else {
      setFormData(prev => ({ ...prev, discount_amount: 0 }));
    }
  }, []);

  const handleCreate = async () => {
    if (formData.service_types_supported.length === 0) {
      setError('Please select at least one service type');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const submitData = {
        promo_code: formData.promo_code.toUpperCase().trim(),
        title: formData.title.trim(),
        description: formData.description.trim(),
        status: formData.status,
        usage_limit: parseInt(formData.usage_limit),
        usage_per_user: parseInt(formData.usage_per_user),
        min_order_value: parseFloat(formData.min_order_value),
        discount_amount: parseFloat(formData.discount_amount),
        discount_perc: parseFloat(formData.discount_perc)|| 0,
        fixed_price:parseFloat(formData.fixed_price)|| 0,
        max_discount: parseFloat(formData.max_discount) || 0,
        start_date: new Date(formData.start_date).toISOString(),
        end_date: new Date(formData.end_date).toISOString(),
        service_types_supported: formData.service_types_supported,
        diagnostic_category: formData.diagnostic_category || [],
        applicable_tests: formData.applicable_tests || [], // ADD THIS
        community:formData.community

      };
        // only send relevant discount
        if (discountType === 'flat') {
          submitData.discount_amount = parseFloat(formData.discount_amount);
        }
        else if(discountType ==='fixed_price'){
           submitData.fixed_price = parseFloat(formData.fixed_price);
        } else {
          submitData.discount_perc = parseFloat(formData.discount_perc);
        }
      await axios.post(`${createpromotionsapi}`, submitData);
      setSuccess('Promotion created successfully!');
      setCreateDialogOpen(false);
      fetchPromotions();
      fetchAnalytics();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create promotion');
    } finally {
      setLoading(false);
    }
  };
const formatDateTimeLocal = (dateString) => {
  const d = new Date(dateString);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

  const handleUpdate = async () => {
    setLoading(true);
    setError('');
    
    try {
      const endDate = new Date(formData.end_date);
      const now = new Date();
      
      if (endDate < now && formData.status === 'active') {
        const confirmPast = window.confirm(
          'The end date is in the past. This promotion will be automatically set to expired. Continue?'
        );
        if (!confirmPast) {
          setLoading(false);
          return;
        }
      }
      const updateData = {
        title: formData.title.trim(),
        description: formData.description.trim(),
        status: formData.status,
        usage_limit: parseInt(formData.usage_limit),
        usage_per_user: parseInt(formData.usage_per_user),
        min_order_value: parseFloat(formData.min_order_value),
        start_date: new Date(formData.start_date).toISOString(),
        end_date: new Date(formData.end_date).toISOString(),
        service_types_supported: formData.service_types_supported,
        diagnostic_category: formData.diagnostic_category,
        applicable_tests: formData.applicable_tests,
        community:formData.community

      };
      // Only send relevant discount fields based on type
      if (discountType === 'flat') {
        updateData.discount_amount = parseFloat(formData.discount_amount);
        updateData.discount_perc = 0;
        updateData.max_discount = 0;
        updateData.fixed_price = 0;
        
      } else if (discountType === 'fixed_price') {
        updateData.fixed_price = parseFloat(formData.fixed_price);
        updateData.discount_perc = 0;
        updateData.max_discount = 0;
      } 
      else {
        updateData.discount_perc = parseFloat(formData.discount_perc);
        updateData.discount_amount = 0;
        updateData.max_discount = parseFloat(formData.max_discount) || 0;
        updateData.fixed_price = 0;
      }
      await axios.put(`${API_BASE_URL}/promotions/${selectedPromo._id}`, updateData);
      setSuccess('Promotion updated successfully!');
      setEditDialogOpen(false);
      fetchPromotions();
      fetchAnalytics();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update promotion');
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async () => {
    setLoading(true);
    try {
      await axios.delete(`${API_BASE_URL}/promotions/${selectedPromo._id}`);
      setSuccess('Promotion deleted successfully!');
      setDeleteDialogOpen(false);
      fetchPromotions();
      fetchAnalytics();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Failed to delete promotion');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const filteredPromotions = promotions.filter(promo =>
    promo.promo_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
    promo.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (promo.description && promo.description.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const StatCard = ({ title, value, icon: Icon, gradient }) => (
    <Card sx={{ 
      height: '100%',
      background: gradient,
      color: 'white',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 6
      }
    }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography color="rgba(255,255,255,0.9)" variant="body2" gutterBottom fontWeight={500}>
              {title}
            </Typography>
            <Typography variant="h3" fontWeight="bold">
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255,255,255,0.2)',
            }}
          >
            <Icon sx={{ fontSize: 28 }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );

  const AnalyticsTab = () => (
    <Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Promotions"
            value={analytics?.total_promotions || 0}
            icon={OfferIcon}
            gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Active Promotions"
            value={analytics?.active_promotions || 0}
            icon={TrendingUpIcon}
            gradient="linear-gradient(135deg, #10b981 0%, #059669 100%)"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Inactive Promotions"
            value={analytics?.inactive_promotions || 0}
            icon={PeopleIcon}
            gradient="linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Usage Limit"
            value={analytics?.total_usage_limit || 0}
            icon={ShoppingCartIcon}
            gradient="linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
          />
        </Grid>
      </Grid>

      {analytics?.total_discount_given && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Total Discount Given
                </Typography>
                <Typography variant="h3" color="success.main" fontWeight="bold">
                  ₹{analytics.total_discount_given.toLocaleString()}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Total Usage Count
                </Typography>
                <Typography variant="h3" color="primary.main" fontWeight="bold">
                  {analytics.total_usage || 0}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Recent Promotions
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Promo Code</strong></TableCell>
                <TableCell><strong>Title</strong></TableCell>
                <TableCell><strong>Status</strong></TableCell>
                <TableCell><strong>Discount</strong></TableCell>
                <TableCell><strong>Valid Until</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {promotions.slice(0, 5).map((promo) => (
                <TableRow key={promo._id}>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {promo.promo_code}
                    </Typography>
                  </TableCell>
                  <TableCell>{promo.title}</TableCell>
                  <TableCell>
                    <Chip
                      label={promo.status.toUpperCase()}
                      color={promo.status === 'active' ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    {promo.discount_amount > 0
                      ? `₹${promo.discount_amount}`
                      : `${promo.discount_perc}%`}
                  </TableCell>
                  <TableCell>{formatDate(promo.end_date)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );

  const PromotionsTab = () => (
    <Box>
      <Paper sx={{ p: 2.5, mb: 3, display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>
        <TextField
          placeholder="Search promotions..."
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
          sx={{ flexGrow: 1, minWidth: 250, maxWidth: 400 }}
        />
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newMode) => newMode && setViewMode(newMode)}
            size="small"
          >
            <ToggleButton value="cards">
              <Tooltip title="Card View">
                <GridViewIcon />
              </Tooltip>
            </ToggleButton>
            <ToggleButton value="table">
              <Tooltip title="Table View">
                <ViewListIcon />
              </Tooltip>
            </ToggleButton>
          </ToggleButtonGroup>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateOpen}
            sx={{
              bgcolor: '#006D77',
              '&:hover': { bgcolor: '#005c64' },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Create Promotion
          </Button>
        </Box>
      </Paper>

      {viewMode === 'cards' && (
        loading && filteredPromotions.length === 0 ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : filteredPromotions.length === 0 ? (
          <Paper sx={{ p: 8, textAlign: 'center' }}>
            <OfferIcon sx={{ fontSize: 64, opacity: 0.3, mb: 2 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No promotions found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {searchQuery ? 'Try adjusting your search' : 'Create your first promotion to get started'}
            </Typography>
          </Paper>
        ) : (
          <Grid container spacing={3}>
            {filteredPromotions.map((promo) => (
              <Grid item xs={12} md={6} lg={4} key={promo._id}>
                <Card sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: 6,
                    transform: 'translateY(-4px)'
                  }
                }}>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                      <Box>
                        <Typography variant="h6" fontWeight="bold" sx={{ color: '#006D77' }}>
                          {promo.promo_code}
                        </Typography>
                        <Typography variant="body1" fontWeight="600" sx={{ mt: 0.5 }}>
                          {promo.title}
                        </Typography>
                      </Box>
                      <Chip
                        label={promo.status.toUpperCase()}
                        color={promo.status === 'active' ? 'success' : 'default'}
                        size="small"
                        sx={{ fontWeight: 600 }}
                      />
                    </Box>

                    <Typography color="text.secondary" sx={{ mb: 2, minHeight: 40 }}>
                      {promo.description}
                    </Typography>

                    <Box sx={{ bgcolor: '#f1f5f9', borderRadius: 2, p: 2, mb: 2 }}>
                      <Typography variant="h5" fontWeight="bold" color="#006D77">
                        {promo.discount_amount > 0
                          ? `₹${promo.discount_amount}`
                          : `${promo.discount_perc}%`}
                        <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                          discount
                        </Typography>
                      </Typography>
                      {promo.max_discount > 0 && (
                        <Typography variant="caption" color="text.secondary">
                          Max discount: ₹{promo.max_discount}
                        </Typography>
                      )}
                    </Box>

                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                          <Typography variant="body2" color="text.secondary">
                            Min Order
                          </Typography>
                          <Typography variant="h6" fontWeight="bold" color="primary">
                            ₹{promo.min_order_value}
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                          <Typography variant="body2" color="text.secondary">
                            Usage Limit
                          </Typography>
                          <Typography variant="h6" fontWeight="bold" color="primary">
                            {promo.usage_per_user}/{promo.usage_limit}
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 1 }}>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                        Services
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {promo.service_types_supported.map(service => (
                          <Chip
                            key={service}
                            label={service}
                            size="small"
                            sx={{ bgcolor: '#e0f2f1', color: '#006D77', fontWeight: 600 }}
                          />
                        ))}
                      </Box>
                    </Box>

                    <Typography variant="caption" color="text.secondary" display="block">
                      Valid until: {formatDate(promo.end_date)}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ p: 2, pt: 0, gap: 1 }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<EditIcon />}
                      onClick={() => handleEditOpen(promo)}
                      sx={{ 
                        textTransform: 'none',
                        color: '#006D77',
                        borderColor: '#006D77',
                        '&:hover': {
                          borderColor: '#005c64',
                          bgcolor: 'rgba(0, 109, 119, 0.04)'
                        }
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={() => handleDeleteOpen(promo)}
                      sx={{ textTransform: 'none' }}
                    >
                      Delete
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )
      )}

      {viewMode === 'table' && (
        <Paper sx={{ p: 0 }}>
          {loading && filteredPromotions.length === 0 ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : filteredPromotions.length === 0 ? (
            <Box textAlign="center" py={4}>
              <OfferIcon sx={{ fontSize: 64, opacity: 0.3, mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No promotions found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {searchQuery ? 'Try adjusting your search' : 'Create your first promotion to get started'}
              </Typography>
            </Box>
          ) : (
            <TableContainer>
              <Table>
                <TableHead sx={{ bgcolor: '#f8fafc' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>Promo Code</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Title</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Discount</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Min Order</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Services</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Usage</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Valid Until</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 700 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredPromotions.map((promo) => (
                    <TableRow key={promo._id} hover>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold" color="#006D77">
                          {promo.promo_code}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600">
                          {promo.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {promo.description}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={promo.status.toUpperCase()}
                          color={promo.status === 'active' ? 'success' : 'default'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">
                          {promo.discount_amount > 0
                            ? `₹${promo.discount_amount}`
                            : `${promo.discount_perc}%`}
                        </Typography>
                        {promo.max_discount > 0 && (
                          <Typography variant="caption" display="block" color="text.secondary">
                            Max: ₹{promo.max_discount}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>₹{promo.min_order_value}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                          {promo.service_types_supported.map(service => (
                            <Chip
                              key={service}
                              label={service}
                              size="small"
                              sx={{ fontSize: '0.7rem' }}
                            />
                          ))}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={`${promo.usage_per_user}/${promo.usage_limit}`}
                          size="small"
                          variant="outlined"
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>{formatDate(promo.end_date)}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="Edit">
                          <IconButton
                            onClick={() => handleEditOpen(promo)}
                            size="small"
                            sx={{ color: '#006D77' }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteOpen(promo)}
                            size="small"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Paper>
      )}
    </Box>
  );
  const OfferManagementTab = () => (
  <Box>

    <Paper
      sx={{
        p: 2,
        mb: 3,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        Offer
      </Typography>

      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => {
          setEditingOffer(null);

          setOfferForm({
            type: "offer",
            active: true,
            priority: 0,

            tag: "",
            headline: "",
            sub: "",
            body: "",

            visual: "💊",

            bigNumber: "",
            bigLabel: "",

            pills: [],

            accentColor: "#80ED99",
            glowColor: "rgba(128,237,153,0.35)",

            backgroundImage: "/med_icon5.png",

            whatsappNumber: "",
            phoneNumber: "",

            buttonLabel: "WhatsApp Order →",
            secondaryButtonLabel: "Call Now",
            community:""
          });

          setOfferDialogOpen(true);
        }}
        sx={{
          bgcolor: "#006D77",
          "&:hover": {
            bgcolor: "#005c64"
          }
        }}
      >
        Add Offer
      </Button>
    </Paper>

    <Grid container spacing={3}>
      {offers.map((offer) => (
        <Grid item xs={12} md={6} lg={4} key={offer.id}>

          <Card
            sx={{
              height: "100%",
              borderRadius: 4,
              overflow: "hidden"
            }}
          >

            <Box
              sx={{
                p: 3,
                color: "#fff",
                background: `
                  linear-gradient(
                    135deg,
                    rgba(0,109,119,0.88),
                    rgba(0,169,181,0.72)
                  )
                `
              }}
            >
              <Typography variant="body2">
                {offer.tag}
              </Typography>

              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ mt: 1 }}
              >
                {offer.headline}
              </Typography>

              <Typography variant="body2">
                {offer.sub}
              </Typography>

              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{ mt: 2 }}
              >
                {offer.bigNumber}
              </Typography>

              <Typography>
                {offer.bigLabel}
              </Typography>
            </Box>

            

            <CardActions sx={{ p: 2 }}>

              <Button
                fullWidth
                variant="outlined"
                onClick={() => {

                  setEditingOffer(offer);

                  setOfferForm({
                    ...offer,
                    pills: offer.pills || []
                  });

                  setOfferDialogOpen(true);
                }}
              >
                Edit
              </Button>

              <Button
                fullWidth
                color="error"
                variant="outlined"
                onClick={() =>
                  handleDeleteOffer(offer.id)
                }
              >
                Delete
              </Button>

            </CardActions>

          </Card>

        </Grid>
      ))}
    </Grid>
  </Box>
);

  const renderFormFields = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="Promo Code"
          name="promo_code"
          value={formData.promo_code}
          onChange={handleInputChange}
          disabled={editDialogOpen}
          inputProps={{ style: { textTransform: 'uppercase' } }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="Title"
          name="title"
          value={formData.title}
          onChange={handleInputChange}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel>Discount Type *</FormLabel>
          <RadioGroup
            row
            value={discountType}
            onChange={handleDiscountTypeChange}
          >
            <FormControlLabel value="flat" control={<Radio />} label="Flat Amount" />
            <FormControlLabel value="percentage" control={<Radio />} label="Percentage" />
            <FormControlLabel value="fixed_price" control={<Radio />} label="Fixed Price" />
          </RadioGroup>
        </FormControl>
      </Grid>


{/* FLAT AMOUNT */}
{discountType === 'flat' && (
  <>
    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        required
        type="number"
        label="Discount Amount (₹)"
        name="discount_amount"
        value={formData.discount_amount}
        onChange={handleInputChange}
        inputProps={{ min: 1 }}
      />
    </Grid>

    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        type="number"
        label="Max Discount (₹)"
        name="max_discount"
        value={formData.max_discount}
        onChange={handleInputChange}
        inputProps={{ min: 0 }}
      />
    </Grid>
  </>
)}
{/* FLAT AMOUNT */}
{discountType === 'fixed_price' && (
  <>
    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        required
        type="number"
        label="Fixed Price (₹)"
        name="fixed_price"
        value={formData.fixed_price}
        onChange={handleInputChange}
        inputProps={{ min: 1 }}
      />
    </Grid>
  </>
)}

{/* PERCENTAGE */}
{discountType === 'percentage' && (
  <>
    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        required
        type="number"
        label="Discount Percentage (%)"
        name="discount_perc"
        value={formData.discount_perc}
        onChange={handleInputChange}
        inputProps={{ min: 1, max: 100 }}
      />
    </Grid>

    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        type="number"
        label="Max Discount (₹)"
        name="max_discount"
        value={formData.max_discount}
        onChange={handleInputChange}
        inputProps={{ min: 0 }}
      />
    </Grid>
  </>
)}

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          type="number"
          label="Minimum Order Value (₹)"
          name="min_order_value"
          value={formData.min_order_value}
          onChange={handleInputChange}
          inputProps={{ min: 0 }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          type="number"
          label="Total Usage Limit"
          name="usage_limit"
          value={formData.usage_limit}
          onChange={handleInputChange}
          inputProps={{ min: 1 }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          type="number"
          label="Usage Per User"
          name="usage_per_user"
          value={formData.usage_per_user}
          onChange={handleInputChange}
          inputProps={{ min: 1 }}
        />
      </Grid>
      <Grid item xs={12}>
          <TextField
            select
            fullWidth 
            label="Community*"
            name="community"
            value={formData.community || ""}
            onChange={handleInputChange}
            sx={{width:200}}
          >
            <MenuItem value="">
              Select Community
            </MenuItem>

            {communities.map((community) => (
              <MenuItem
                key={community._id || community.id}
                value={community.name}
              >
                {community.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

      <Grid item xs={12}>
        <FormControl component="fieldset" required>
          <FormLabel>Service Types </FormLabel>
          <FormGroup row>
            {SERVICE_TYPES.map(service => (
              <FormControlLabel
                key={service.value}
                control={
                  <Checkbox
                    value={service.value}
                    checked={
                      service.value === "all"
                        ? formData.service_types_supported.includes("medicine") &&
                          formData.service_types_supported.includes("diagnostic")  && formData.service_types_supported.includes("nursingAndPhysio")
                        : formData.service_types_supported.includes(service.value)
                    }
                    onChange={handleServiceTypeChange}
                  />
                }
                label={service.label}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Grid>
      {formData.service_types_supported.includes("diagnostic") && (
  <Grid item xs={12}>
  <FormControl fullWidth>
    <InputLabel>Diagnostic Categories</InputLabel>

    <Select
    sx={{width:"180px"}}
      multiple
      
      value={formData.diagnostic_category || "select"}
      onChange={(e) => {
        const selectedCategories = e.target.value;

        setFormData((prev) => ({
          ...prev,
          diagnostic_category: selectedCategories,
          applicable_tests: []
        }));

        fetchDiagnosticTests(selectedCategories);
      }}
      renderValue={(selected) => selected.join(", ")}
    >
      {diagnosticCategories.map((category) => (
        <MenuItem key={category.name} value={category.name}>
          <Checkbox
            checked={
              (formData.diagnostic_category || []).includes(category.name)
            }
          />
          <ListItemText primary={category.name} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
)}

{formData.diagnostic_category?.length > 0  && (
  <Grid item xs={12}>
    <FormControl fullWidth>
      <InputLabel>Select Tests</InputLabel>

      <Select
        sx={{width:"180px"}}
        multiple
        value={formData.applicable_tests || []}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            applicable_tests: e.target.value
          }))
        }
        renderValue={(selected) =>
          diagnosticTests
            .filter((test) => selected.includes(test.id))
            .map((test) => test.test_name)
            .join(", ")
        }
      >
        {diagnosticTests.map((test) => (
          <MenuItem key={test.id} value={test.id}>
            <Checkbox
              checked={(formData.applicable_tests || []).includes(test.id)}
            />
            <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 1
  }}
>
  <Typography
    sx={{
      maxWidth: "280px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "14px"
    }}
  >
    {test.test_name}
  </Typography>

  <Typography
    variant="caption"
    sx={{
      color: "#006D77",
      fontWeight: 600,
      cursor: "pointer",
      whiteSpace: "nowrap"
    }}
    onClick={(e) => {
      e.stopPropagation();
      setDialogOpen(true);
      setPromotype("full name")
      setPromotype("info")
      setDialogMessage(test.test_name);
    }}
  >
    Full test name
  </Typography>
</Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)}

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          type="datetime-local"
          label="Start Date & Time"
          name="start_date"
          value={formData.start_date}
          onChange={handleInputChange}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          type="datetime-local"
          label="End Date & Time"
          name="end_date"
          value={formData.end_date}
          onChange={handleInputChange}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', py: 4 }}>
      <Container maxWidth="xl" sx={{ ml: { md: '300px' } }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h3" fontWeight="bold" sx={{ mb: 1, color: '#1e293b' }}>
            Promotion Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage promotion codes and monitor performance
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
            {success}
          </Alert>
        )}

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs 
            value={tabValue} 
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{
              '& .MuiTab-root': { 
                color: '#006D77',
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 500
              },
              '& .Mui-selected': { 
                color: '#006D77 !important', 
                fontWeight: 'bold' 
              },
            }}
          >
            <Tab label="Analytics" />
            <Tab label="All Promotions" />
            <Tab label="Offer Management" />
            <Tab label="Referral Configuration" /> 
            
          </Tabs>
        </Box>

        {tabValue === 0 && <AnalyticsTab />}
        {tabValue === 1 && <PromotionsTab />}
        {tabValue === 2 && <OfferManagementTab />}
        {tabValue === 3 && <ReferralConfigTab />}

        
        <CustomDialog open={dialogOpen} message={dialogMessage} title={promoMsg} type={promotype} onClose={() => setDialogOpen(false)} />
        

        <Dialog open={createDialogOpen} onClose={() => setCreateDialogOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
          Create New Promotion
        </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ mt: 2 }}>
              {renderFormFields()}
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button 
              onClick={() => setCreateDialogOpen(false)}  
              variant="outlined"
              sx={{ 
                color: '#006D77', 
                borderColor: '#006D77',
                textTransform: 'none'
              }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleCreate} 
              variant="contained" 
              disabled={loading}
              sx={{
                bgcolor: '#006D77', 
                color: '#fff', 
                '&:hover': { bgcolor: '#005c64' },
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              {loading ? <CircularProgress size={24} /> : 'Create'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>
            <Typography variant="h5" fontWeight="bold">
              Edit Promotion
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ mt: 2 }}>
              {renderFormFields()}
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button 
              onClick={() => setEditDialogOpen(false)} 
              variant="outlined"
              sx={{ 
                color: '#006D77', 
                borderColor: '#006D77',
                textTransform: 'none'
              }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleUpdate} 
              variant="contained" 
              disabled={loading}
              sx={{
                bgcolor: '#006D77', 
                color: '#fff', 
                '&:hover': { bgcolor: '#005c64' },
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              {loading ? <CircularProgress size={24} /> : 'Update'}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete the promotion "{selectedPromo?.promo_code}"? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button 
              onClick={() => setDeleteDialogOpen(false)} 
              variant="outlined"
              sx={{ 
                color: '#006D77', 
                borderColor: '#006D77',
                textTransform: 'none'
              }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleDelete} 
              variant="contained"
              color="error"
              disabled={loading}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            >
              {loading ? <CircularProgress size={24} /> : 'Delete'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <Dialog
  open={offerDialogOpen}
  onClose={() => setOfferDialogOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>
    {editingOffer ? "Edit Offer" : "Create Offer"}
  </DialogTitle>

  <DialogContent dividers>

    <Grid container spacing={2} sx={{ mt: 1 }}>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Tag"
          value={offerForm.tag}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              tag: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Headline"
          value={offerForm.headline}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              headline: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Sub Title"
          value={offerForm.sub}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              sub: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Body"
          value={offerForm.body}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              body: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Big Number"
          value={offerForm.bigNumber}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              bigNumber: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Big Label"
          value={offerForm.bigLabel}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              bigLabel: e.target.value
            })
          }
        />
      </Grid>
       <Grid item xs={12}>
        <TextField
          fullWidth
          label="Visual"
          value={offerForm.visual}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              visual: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="WhatsApp Number"
          value={offerForm.whatsappNumber}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              whatsappNumber: e.target.value
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Phone Number"
          value={offerForm.phoneNumber}
          onChange={(e) =>
            setOfferForm({
              ...offerForm,
              phoneNumber: e.target.value
            })
          }
        />
      </Grid>
      <Grid item xs={12}>
          <TextField
            select
            fullWidth 
            label="Community*"
            name="community"
            value={offerForm.community || ""}
            onChange={(e) =>
            setOfferForm({
              ...offerForm,
              community: e.target.value
            })}
            sx={{width:200}}
          >
            <MenuItem value="">
              Select Community
            </MenuItem>

            {communities.map((community) => (
              <MenuItem
                key={community._id || community.id}
                value={community.name}
              >
                {community.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

    </Grid>

  </DialogContent>

  <DialogActions>

    <Button
      onClick={() =>
        setOfferDialogOpen(false)
      }
    >
      Cancel
    </Button>

    <Button
      variant="contained"
      onClick={handleSaveOffer}
      sx={{
        bgcolor: "#006D77"
      }}
    >
      Save
    </Button>

  </DialogActions>
</Dialog>
    </Box>
  );
};

export default PromotionDashboard;



